import React from "react";
import { useEffect, useRef } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

import {
  faHandPointUp,
} from '@fortawesome/free-solid-svg-icons'

import "./TopButton.css";

library.add(fas, faHandPointUp);


const TopButton = () => {
  const buttonRef = useRef(null);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const scrollFunction = () => {
      if (!buttonRef.current) return;

      if (window.scrollY > 20) {
        buttonRef.current.style.visibility = "visible";
      } else {
        buttonRef.current.style.visibility = "hidden";
      }
    };

    // Initial check
    scrollFunction();

    window.addEventListener("scroll", scrollFunction);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("scroll", scrollFunction);
    };
  }, []);

  return (
    <button
      ref={buttonRef}
      onClick={scrollToTop}
      id="topButton"
      title="Go to top"
      style={{ visibility: "hidden" }} // hidden by default
    >
      <FontAwesomeIcon icon="fa-solid fa-hand-point-up" />
    </button>
  );
};

export default TopButton;
